import axios from 'axios';
import {config} from '../config';

// const apiEndpoint = process.env.PAYPOINT_BACKEND_API_ENDPOINT ? 
// process.env.PAYPOINT_BACKEND_API_ENDPOINT :
// "https://testapi.cloudconnect.ml:8080"

export const loginService = (credentials) => {
    return axios.post(`${config.endpoint}/v1/login`, credentials)
        // .then(
        //     (response) => response
        // )
        .then((response) => {return response;})
        .catch(error => {return error;}); 
        // .catch(error => {
        //     alert("Something went wrong while Login. Please Try again");
        // });
};
export const terminalDetailService = (AuthToken) => {
    return axios.get(`${config.endpoint}/v1/terminal`, { headers: { Authorization: 'bearer ' + AuthToken } })
        .then(
            (response) => response
        ).catch(error => {
            alert('Something went wrong while fetching terminals. Please Try again');
        });
};